import { React, useState } from 'react';
import Box from '@iso/components/utility/box';
import Button from '@iso/components/uielements/button';
import { useContext } from 'react';
import { Spin, Tooltip, Input, Form } from 'antd';
import CloseIcon from '@iso/assets/images/icon/07-icon.svg';
import styled from 'styled-components';
import { SelectOption } from '@iso/components/uielements/select';
import { useEffect } from 'react';
import { AppContext } from '../../../context/ContextProvider';
import Select from '@iso/containers/Projects/AddEnvironmentVariable.style';
import { AlertContext } from '../../../context/alertContext';
import api from '../../../api';
import { formatErrors, hasPermission } from '../../../context/helper';
import UploadFiles from '@iso/components/utility/UploadFiles';
import { InfoCircleFilled } from '@ant-design/icons';
import { CustomModal } from '../../Dashboard/CustomComponents/PageLoader.style';
import { useDeploymentFeatures } from '../../Dashboard/CustomHooks/useDeploymentFeatures';

const Option = SelectOption;

let titleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontSize: "16px",
    fontWeight: "500"
}

let subTitleStyle = {
    fontSize: "14px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontType: "regular",
    fontWeight: "400"
}

const ProdContentHold = styled.div`
  .isoBoxWrapper {
    height: auto;
    border: none;
    margin: 0;
  }

  .isoHelperText {
    color: red;
    font-weight: 400;
    font-size: 12px;
    margin-top: 30%;
    display: flex;
    justify-content: center;
  }

  .header__center {
    font-size: 15px;
    display: grid;
    grid-template-columns: 1fr max-content 1fr;
    grid-column-gap: 1.2rem;
    align-items: center;
    color: #7C7C7C;
    margin: 50px;
    margin-inline: 49px;
  }

  .header__center::before, .header__center::after {
    content: "";
    display: block;
    height: 1px;
    background-color: #F4F4F4;
  }
`;

const buttonCss = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px 46px"
};

const footerStyle = {
    width: "100%",
    position: "absolute",
    bottom: "0",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "20px 10px",
    borderTop: "1px solid #B1B1B1",
    background: "#FFF",
}

export default ({
    data,
    type,
    fromWorkflow,
    setEnvVarsList,
    accountDetails,
    setAccountDetails,
}) => {

    const { openRightDrawer, setOpenRightDrawer } = useContext(AppContext);
    const { set_alertOptions } = useContext(AlertContext);
    const { toggleAlert } = useDeploymentFeatures();

    const [form] = Form.useForm();

    // Check if accountDetails has account_id (secret manager is configured)
    const hasSecretManager = accountDetails && typeof accountDetails === 'object' && accountDetails !== "Atmosly" && accountDetails.account_id;

    const [importData, setImportData] = useState({
        importOption: type === "terraform" ? "" : "Upload .env file",
        file: "",
        secretFile: "",
        uploadContent: false,
    });

    const [file, setFile] = useState(null);
    const [jsonData, setJsonData] = useState();
    const [importOptions, setImportOptions] = useState([]);
    const [secretList, setSecretList] = useState([]);
    const [error, setError] = useState({
        status: false,
        msg: "Success"
    });
    const [secretLoad, setSecretLoad] = useState(false);
    const [loadingSecrets, setLoadingSecrets] = useState(false);

    useEffect(() => {
        form.setFieldsValue({ ...importData });
    }, [importData]);

    useEffect(() => {
        console.log("Executing this useEffect");
        let options = type === "terraform" ? ["Upload .tf file"] : ["Upload .env file"];
        
        // Add "Secrets" option if hasSecretManager
        if (hasSecretManager && !fromWorkflow) {
            options.push("Secrets");
        }
        
        let importOpts = [];
        options.forEach((val) => {
            if (hasSecretManager && val === "Secrets") {
                importOpts.push(<Option key={val} name="importOption" value={val} title={!hasPermission('create_secret') && "You don't have permission to perform this action."} disabled={!hasPermission('create_secret')}>
                    {val}
                </Option>);
            } else {
                importOpts.push(<Option key={val} name="importOption" value={val}>
                    {val}
                </Option>);
            }
        });
        setImportOptions([...importOpts]);
    }, [hasSecretManager]);

    useEffect(() => {
        console.log("Import data.importOption: ", importData.importOption);
        if (importData.importOption === "Secrets" && hasSecretManager) {
            setSecretLoad(true);
            api.get(process.env.REACT_APP_API_URI + `/api/integration/secret-manager/list/secrets/${accountDetails?.region}/${accountDetails?.account_id}`)
                .then((res) => {
                    let responseData = res.data;
                    if (responseData.status) {
                        let secrets = [];
                        responseData.data.forEach((val) => {
                            secrets.push(<Option name="secretFile" key={val} value={val}>
                                {val}
                            </Option>);
                        });
                        setSecretList([...secrets]);
                    }
                    else {
                        console.log("Error");
                        setError({
                            msg: responseData.error_details?.error || "Failed to fetch secrets",
                            status: true
                        });
                    }
                    setSecretLoad(false);
                }).catch((err) => {
                    console.log("Error");
                    setError({
                        msg: "Failed to fetch secrets from secret manager",
                        status: true
                    });
                    setSecretLoad(false);
                });
        }
    }, [importData.importOption]);

    const handelClick = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
                columnId: ""
            },
        });
    }

    const handleReadFile = (file) => {
        const reader = new FileReader();
        console.log("Files :", file);
        setError({ ...error, status: false });

        reader.onload = (e) => {
            try {
                setJsonData(e.target.result);
                setImportData({ ...importData, uploadContent: true });
                toggleAlert("success", "Success", `${file.name} uploaded successfully. Please proceed.`);
            } catch (error) {
                console.error(`Error parsing ${type === "terraform" ? `.tf` : `.env`} file:`, error);
            }
        };

        if (file) {
            setFile({
                ...file,
                uid: file.uid,
                name: file.name,
                status: 'done',
            });
            reader.readAsText(file);
        }
    };

    const handleSelectChange = (value, event) => {
        console.log("inside handleSelectChange");
        setImportData({ ...importData, [event.name]: value });
        setError({ ...error, status: false });
    }

    function parseTerraformVariablesList(tfContent) {
        const results = [];
        // Matches: variable "foo" { … }
        const varBlockRE = /variable\s+"([^"]+)"\s*{([\s\S]*?)^}/gm;
        // Matches: type = something
        const typeRE = /type\s*=\s*(?:(["'])([\s\S]*?)\1|([^\r\n#]+))/;
        // Matches: default = something
        const defaultRE = /default\s*=\s*(?:(["'])([\s\S]*?)\1|([^\r\n#]+))/;

        let m;
        while ((m = varBlockRE.exec(tfContent)) !== null) {
            const [, name, body] = m;
            let type = null;
            let def = null;

            const t = typeRE.exec(body);
            if (t) {
                type = (t[2] ?? t[3]).trim();
            }

            const d = defaultRE.exec(body);
            if (d) {
                def = (d[2] ?? d[3]).trim();
            }

            results.push({ name, type, default: def });
        }

        return results;
    }

    // function toggleAlert(type, message, description) {
    //     set_alertOptions(alertOptions => ({
    //         status: true,
    //         type: type,
    //         message: message,
    //         description: description,
    //     }));

    //     setTimeout(() => {
    //         set_alertOptions(alertOptions => ({
    //             status: false,
    //             type: type,
    //             message: message,
    //             description: description,
    //         }));
    //     }, 5 * 1000);
    // }

    const handelCreate = async (e) => {
        console.log("inside handelCreate importData:", importData);

        // Get existing env var names for duplicate checking
        let allEnvNames = [];
        if (data && Array.isArray(data)) {
            data.forEach((temp) => {
                if (temp.varName) {
                    allEnvNames.push(temp.varName);
                }
            });
        }

        if (["Upload .tf file", "Upload .env file"].includes(importData.importOption)) {
            if (importData.uploadContent) {
                console.log("jsonData :", jsonData);
                let rawData = "";

                if (jsonData) {
                    if (type === "terraform") {
                        rawData = parseTerraformVariablesList(jsonData);
                    } else {
                        rawData = jsonData.split("\r\n");
                        if (rawData[0] && rawData[0].includes("\n")) {
                            console.log("Includes \n instead of \r\n ");
                            rawData = jsonData.split("\n");
                        }
                    }

                    console.log("rawData :", rawData);

                    let tempEnvs = [];
                    if (rawData.length > 0) {
                        rawData.forEach((temp, idx) => {
                            if (type === "terraform") {
                                // Handle terraform parsed data
                                let key = temp.name ? temp.name.trim() : "";
                                let value = temp.default !== null && temp.default !== undefined ? temp.default : "";
                                
                                if (key) {
                                    tempEnvs.push({
                                        id: idx + (data?.length > 0 ? data.length : 0),
                                        key: idx + (data?.length > 0 ? data.length : 0),
                                        varName: key,
                                        originalKey: key,
                                        valueFrom: "Value",
                                        value: value,
                                        isSecret: false,
                                        dependOn: null,
                                        error: allEnvNames.includes(key) ? true : false,
                                        isHide: false,
                                        keys: key,
                                        syncProj: false,
                                        injectAt: fromWorkflow ? ["Build Time"] : ["Run Time"],
                                        type: temp.type || "",
                                        isNew: true,
                                    });
                                    allEnvNames.push(key);
                                }
                            } else if (!temp.trim().startsWith("#") && !temp.trim().startsWith("//") && temp.includes("=")) {
                                let firstEqualsIndex = temp.indexOf("=");
                                let key = temp.substring(0, firstEqualsIndex).trim();
                                let value = temp.substring(firstEqualsIndex + 1).trim();

                                if (key) {
                                    tempEnvs.push({
                                        id: idx + (data?.length > 0 ? data.length : 0),
                                        key: idx + (data?.length > 0 ? data.length : 0),
                                        varName: key,
                                        originalKey: key,
                                        valueFrom: "Value",
                                        value: value,
                                        isSecret: false,
                                        dependOn: null,
                                        error: !value || allEnvNames.includes(key) ? true : false,
                                        isHide: false,
                                        keys: key,
                                        syncProj: false,
                                        injectAt: fromWorkflow ? ["Build Time"] : ["Run Time"],
                                        isNew: true,
                                    });

                                    allEnvNames.push(key);
                                }
                            }
                        });

                        console.log("tempEnvs :", tempEnvs);

                        setEnvVarsList([
                            ...data,
                            ...tempEnvs
                        ]);

                        toggleAlert("success", "Success", "Environment variables imported successfully.");
                        handelClick();
                    }
                }
                else {
                    setError({
                        status: true,
                        msg: "No variables found."
                    });
                }
            }
        }
        else if (importData.importOption === "Secrets" && hasSecretManager) {
            if (importData.secretFile === "") {
                setError({
                    status: true,
                    msg: "Please Fill all fields marked with *"
                });
            }
            else {
                setLoadingSecrets(true);
                api.get(process.env.REACT_APP_API_URI + `/api/project_env/secrets?region=${accountDetails?.region}&account_id=${accountDetails?.account_id}&secret_name=${importData.secretFile}`)
                    .then((res) => {
                        let responseData = res.data;
                        console.log("data in get_env_file api :", responseData);
                        if (!responseData.status) {
                            let err = formatErrors(responseData.error_details);
                            setError({
                                msg: err,
                                status: true
                            });
                        }
                        else {
                            if (responseData.data && Object.keys(responseData.data).length > 0) {
                                let tempEnvs = [];
                                let convertEnvs = [];

                                Object.keys(responseData.data).forEach((val) => {
                                    convertEnvs.push({
                                        [val]: responseData.data[val].toString()
                                    });
                                });

                                convertEnvs.forEach((temp, idx) => {
                                    let key = Object.keys(temp)[0];
                                    let value = Object.values(temp)[0];

                                    tempEnvs.push({
                                        id: idx + (data?.length > 0 ? data.length : 0),
                                        key: idx + (data?.length > 0 ? data.length : 0),
                                        varName: key,
                                        originalKey: key,
                                        valueFrom: "Value",
                                        value: value,
                                        isSecret: true,
                                        isHide: true,
                                        dependOn: null,
                                        importFrom: "Secret Manager",
                                        error: !value || allEnvNames.includes(key) ? true : false,
                                        injectAt: fromWorkflow ? ["Build Time"] : ["Run Time"],
                                        keys: key,
                                        syncProj: false,
                                        isNew: true,
                                    });
                                    allEnvNames.push(key);
                                });

                                console.log("tempEnvs :", tempEnvs);

                                setEnvVarsList([
                                    ...data,
                                    ...tempEnvs
                                ]);

                                toggleAlert("success", "Success", "Environment variables imported successfully from Secret Manager.");
                                handelClick();
                            }
                            else {
                                setError({
                                    status: true,
                                    msg: "No secrets found."
                                });
                            }
                        }
                        setLoadingSecrets(false);
                    })
                    .catch((err) => {
                        console.log("Error :", err);
                        toggleAlert("error", "Error", "Something went wrong. Please try again.");
                        setLoadingSecrets(false);
                    });
            }
        }
    }

    return (
        <>
            <CustomModal
                visible={loadingSecrets}
                footer={null}
                closable={false}
                centered
                maskClosable={false}
                style={{ border: "none", boxShadow: "none" }}
            >
                <div style={{ textAlign: 'center', background: "transparent", border: "none" }}>
                    <Spin size="large" />
                </div>
            </CustomModal>

            <Form
                form={form}
                initialValues={{ ...importData }}
                preserve={false}
                name="dynamic_rule"
                style={{
                    width: "100%",
                    height: "fit-content"
                }}
            >
                <ProdContentHold className='addEnvVar' style={{}}>
                    <Box
                        title="Select to import*"
                        subtitle=""
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{ paddingInline: "49px", marginTop: "105px" }}
                    >
                        <Select
                            value={importData.importOption}
                            onChange={handleSelectChange}
                            className="custom-ant-selector"
                            placeholder="Select"
                        >
                            {importOptions}
                        </Select>
                    </Box>
                    {/* Header */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "rgb(19, 47, 68)" }}>
                        <Box
                            title={
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    fontSize: "14px"
                                }}>
                                    <span className="header-text">Import Variable</span>
                                    <img src={CloseIcon} style={{ cursor: "pointer", width: "20px", height: "20px", transform: "translateY(15px)" }} alt="close Icon" onClick={handelClick} />
                                </div>
                            }
                            subtitle="Enter details to import new variable"
                            titleStyle={{
                                fontWeight: '500',
                                fontFamily: "Nunito Sans",
                                fontSize: '14px',
                                color: "#ffffff"
                            }}
                            subTitleStyle={{
                                fontWeight: '400',
                                fontFamily: "Nunito Sans",
                                fontSize: '13px',
                                color: "#ffffff"
                            }}
                            style={{
                                position: "absolute",
                                zIndex: "1",
                                width: "100%",
                                top: "0px",
                                height: "83px",
                                backgroundColor: "rgb(19, 47, 68)"
                            }}
                        />
                    </div>
                    {/* Content */}
                    {["Upload .tf file", "Upload .env file"].includes(importData.importOption) && <Box
                        title={`Upload ${type === "terraform" ? `.tf` : `.env`} file here*`}
                        subtitle="File Details"
                        subtitleStyle={subTitleStyle}
                        titleStyle={titleStyle}
                        style={{ paddingInline: "49px" }}
                    >
                        <div style={{ padding: "10px 0" }}>
                            <UploadFiles types={type === "terraform" ? [".tf"] : [".env", ".ENV"]} maxSize={2 * 1024 * 1024} files={file ? [file] : []} setFiles={setFile} handleReadFile={handleReadFile} />
                        </div>
                    </Box>}

                    {importData.importOption === "Secrets" && hasSecretManager && <Box
                        title="Secret Name*"
                        subtitle="Select secret from Secret Manager"
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{ paddingInline: "49px" }}
                    >
                        <Form.Item
                            name="secretFile"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select a secret',
                                }
                            ]}
                        >
                            <Select
                                value={importData.secretFile}
                                onChange={handleSelectChange}
                                className="custom-ant-selector"
                                placeholder="Select secret"
                                style={{ height: "44px" }}
                                notFoundContent={secretLoad ? <Spin size="small" /> : "No secrets found"}
                            >
                                {secretList}
                            </Select>
                        </Form.Item>
                    </Box>}

                    {error.status && !error.type && <p className="isoHelperText" style={{ marginTop: "0" }}>
                        <span>{error.msg}</span>
                    </p>}

                    <div style={{ marginBottom: "100px" }}></div>

                    {/* Footer */}
                    <div style={footerStyle}>
                        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Button className="customButton" style={{ ...buttonCss, marginRight: "30px" }} onClick={() => {
                                setImportData({
                                    ...importData,
                                    file: "",
                                    secretFile: "",
                                    uploadContent: false,
                                });
                                handelClick();
                            }}>
                                Cancel
                            </Button>
                            <Button className="customButtonActive" style={{ ...buttonCss, background: "#132F44", borderRadius: "8px", color: "#FFFFFF" }} onClick={(e) => handelCreate(e)}>
                                Proceed
                            </Button>
                        </div>
                    </div>

                </ProdContentHold>
            </Form>
        </>
    );
};

